/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoSfrIcon20Light = forwardRef('GovKoSfrIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.065 2.588a.5.5 0 0 1 .128.695l-1.718 2.5A.5.5 0 0 1 9.063 6H5.874a3.5 3.5 0 1 0 0 7h.702c.22 0 .426-.107.553-.287l4.922-7.001A1.675 1.675 0 0 1 13.423 5h.702a4.5 4.5 0 1 1 0 9h-2.859l-2.883 4.28a.5.5 0 1 1-.829-.56l3.031-4.5A.5.5 0 0 1 11 13h3.125a3.5 3.5 0 1 0 0-7h-.702a.675.675 0 0 0-.553.287l-4.922 7.001A1.676 1.676 0 0 1 6.577 14h-.702a4.5 4.5 0 1 1 0-9h2.924l1.57-2.283a.5.5 0 0 1 .696-.129Z" })));
});
